var Component = require("!../../../../vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../vue-loader/lib/selector?type=script&index=0!./option.vue"),
  /* template */
  require("!!../../../../vue-loader/lib/template-compiler?id=data-v-6036eb8a!../../../../vue-loader/lib/selector?type=template&index=0!./option.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./~/element-ui/packages/select/src/option.vue
// module id = 966
// module chunks = 2